import UdeskLocales from 'UdeskLocales';
import React, { memo } from 'react';
import { useRequest } from 'ahooks';
import { TreeSelect } from 'udesk-ui';
import { TreeSelectProps } from 'antd';
import Ellipsis from 'src/components/common/Ellipsis';
import { getAgentDepartmentsAll } from 'src/api/agentDepartments/all';
import { AgentDepartmentFoundResponse } from 'src/api/types';
import './style.scss';

interface TemplateProps<T extends number | number[]> extends TreeSelectProps<T> {}

const Template: <T extends number | number[]>(
    props: TemplateProps<T>
) => React.ReactElement | null = memo((props) => {
    const { ...restProps } = props;

    const { data } = useRequest(getAgentDepartmentsAll);

    const transform = (data?: AgentDepartmentFoundResponse[]) => {
        return data?.map((d) => {
            return {
                ...d,
                title: <Ellipsis text={d.departmentName} />,
                value: d.id,
                children: d.children ? transform(d.children) : undefined,
            };
        });
    };

    return (
        <div className="agent-department-select">
            <TreeSelect
                treeData={transform(data?.data)}
                placeholder={
                    /* 请选择部门 */ UdeskLocales['current'].components.agentDepartmentSelect.index
                        .pleaseSelectDepartment
                }
                getPopupContainer={() =>
                    document.querySelector('.agent-department-select') || document.body
                }
                filterTreeNode={(inputValue, treeNode) => {
                    return (treeNode?.props.departmentName || '')
                        .toLowerCase()
                        .includes(inputValue.toLowerCase());
                }}
                {...restProps}
            />
        </div>
    );
});

export default Template;
